import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import TypePageConstant from "./TypePageConstant";
import validationsFormsPageAdd from "../../../validations/forms/page/add";
import helperSpinner from "../../../helpers/spinner";
import httpService from "../../../services/httpServices/httpServices";
import { Link } from "react-router-dom";

export default function AddPageSitePublisher() {
  const params = useParams();
  const publisherID = parseInt(params.publisherID);
  const [urlSitePublisher, setUrlSitePublisher] = useState();
  const [imageFile, setImageFile] = useState();
  const [typePage, setTypePage] = useState(TypePageConstant.typePage.STATIC);
  const [message, setMessage] = useState();

  const history = useHistory();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getSitePublisher();
  }, []);

  const getSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let publisher = await sendRequestGetSitePublisher(publisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!publisher) {
      return;
    }

    setUrlSitePublisher(publisher.url.replace("https://", ""));
  };

  const sendRequestGetSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderRequest();
    let publisher;
    try {
      publisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/site/" + publisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return publisher.data.data;
  };

  const addPageToSitPublisher = async () => {
    let formData = getFormData();
    const resultValidateFormData = validationsFormsPageAdd(formData, typePage);
    if (resultValidateFormData != true) {
      scrollForMessage();
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidateFormData,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    formData["web_site_publisher_id"] = publisherID;
    formData = generateFormDataForRequest(formData);
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultSendRequestAddPageToSitPublisher =
      await sendRequestAddPageToSitPublisher(formData);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddPageToSitPublisher) {
      return;
    }
    history.push(`/page/all/publisher/${publisherID}`);
  };

  const getFormData = () => {
    let pattern = document.querySelector("#pattern").value;

    if (pattern != "/") {
      if (pattern.charAt(pattern.length - 1) == "/") {
        pattern = pattern.slice(0, -1);
      }
    }

    let link = document.querySelector("#link").value;
    if (link.charAt(link.length - 1) == "/") {
      link = link.slice(0, -1);
    }

    return {
      siteUrl: urlSitePublisher.replace("https://", ""),
      title: document.querySelector("#title").value,
      pattern: pattern,
      link: link,
      image: imageFile,
      active: +document.querySelector("#active").checked,
    };
  };

  const generateFormDataForRequest = (dataForm) => {
    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("title", dataForm.title);
    formData.append("pattern", dataForm.pattern);
    formData.append("link", dataForm.link);
    formData.append("web_site_publisher_id", dataForm.web_site_publisher_id);
    formData.append("active", dataForm.active);
    return formData;
  };

  const sendRequestAddPageToSitPublisher = async (dateForm) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/page",
        dateForm,
        headersRequest
      );
      return true;
    } catch (error) {
      scrollForMessage();
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const scrollForMessage = () => {
    const element = document.getElementById("message-box");
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title={`اضافه کردن صفحه به سایت ${urlSitePublisher}`} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/page/all/publisher/${publisherID}`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div id="message-box">{messageTag}</div>
              <div className="alert alert-warning">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      برای آپلود عکس صفحه فقط از فرمت webp استفاده کنید .
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span>الگو آدرس حتما باید با حرف / شروع شود و فاقد</span>
                      <span dir="ltr" className="px-2">
                        https://
                      </span>
                      <span>و دامنه سایت شما باشد.</span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      اگر نوع صفحه شما چند صفحه ای است الگو آدرس شما باید دارای
                      s@ باشد.
                    </p>
                  </li>

                  <hr />
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحات ثابت بصورت زیر , آدرس را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">تماس با ما</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس :</span>
                      <span className="pl-2" dir="ltr">
                        /contact-us
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir/contact-us
                      </span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">درباره با ما</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /about-us
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir/about-us
                      </span>
                    </p>
                  </li>
                  <hr />
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحات متغیر بصورت زیر , آدرس را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحات محصولات</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /product/@s
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir/product/10941
                      </span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحات مطالب</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /blog/@s
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        {decodeURI(
                          "https://monirlock.ir/blog/%d8%a7%d9%86%d9%88%d8%a7%d8%b9-%da%a9%d9%84%db%8c%d8%af-%d9%87%d8%a7%db%8c-%d9%85%d9%86%db%8c%d8%b1-%d8%b5%d9%86%d8%b9%d8%aa"
                        )}
                      </span>
                    </p>
                  </li>
                  <hr />
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحه اصلی , آدرس زیر را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحه اصلی</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir
                      </span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحه چند صفحه ای بدون پیش وند , آدرس زیر
                      را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحات مطالب</span>
                      <span className="pl-2"> - </span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /@s
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        {decodeURI(
                          "https://monirlock.ir/%d8%a7%d9%86%d9%88%d8%a7%d8%b9-%da%a9%d9%84%db%8c%d8%af-%d9%87%d8%a7%db%8c-%d9%85%d9%86%db%8c%d8%b1-%d8%b5%d9%86%d8%b9%d8%aa"
                        )}
                      </span>
                    </p>
                  </li>
                </ul>
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  addPageToSitPublisher();
                }}
              >
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    tabIndex="1"
                    dir="rtl"
                    type="text"
                    id="title"
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>نوع صفحه</label>
                  <div className="d-inline-block pr-2">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setTypePage(e.target.value);
                      }}
                    >
                      <option value={TypePageConstant.typePage.STATIC}>
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.STATIC
                          ]
                        }
                      </option>
                      <option value={TypePageConstant.typePage.MULTI_PAGE}>
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.MULTI_PAGE
                          ]
                        }
                      </option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>الگو آدرس</label>
                  <input
                    tabIndex="3"
                    dir="ltr"
                    type="text"
                    id="pattern"
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>لینک صفحه </label>
                  <input
                    tabIndex="4"
                    dir="ltr"
                    type="text"
                    id="link"
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <span className="pl-2">
                    <label>فعال</label>
                  </span>
                  <span>
                    <label className="adl-switch">
                      <input type="checkbox" id="active" />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <div>
                    <label>عکس صفحه</label>
                  </div>
                  <div>
                    <input
                      type="file"
                      id="image-file"
                      accept="image/webp"
                      required
                      onChange={(e) => {
                        setImageFile(e.target.files[0]);
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <button className="btn btn-success">اضافه کردن</button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
